/* Densgrove – Shop (fs-*) */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function money(cents, fmt, trim) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var intDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var intComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withComma = intDot + ',' + parts[1];
    var withDot = intComma + '.' + parts[1];
    if (trim && parts[1] === '00') { withComma = intDot; withDot = intComma; }
    fmt = fmt || '€{{amount_with_comma_separator}}';
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, intDot)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, intComma)
      .replace(/\{\{\s*amount\s*\}\}/, withDot);
  }

  function promoOver() {
    var el = $('[data-promo-end]');
    if (!el) return true;
    var end = el.getAttribute('data-promo-end');
    return Date.now() > new Date(end + 'T23:59:59+01:00').getTime();
  }

  function gallery() {
    var gal = $('[data-fs-gallery]');
    if (!gal) return;
    var track = $('[data-fs-track]', gal);
    var slides = $$('[data-fs-slide]', gal);
    var thumbs = $$('[data-fs-thumb]', gal);
    var dots = $$('[data-fs-dot]', gal);
    var cur = $('[data-fs-cur]', gal);
    function set(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      dots.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      if (cur) cur.textContent = String(i + 1);
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        set(i);
      });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        set(Math.max(0, Math.min(slides.length - 1, i)));
        ticking = false;
      });
    }, { passive: true });
  }

  function eta() {
    var el = $('[data-fs-eta]');
    if (!el) return;
    var min = parseInt(el.getAttribute('data-min'), 10), max = parseInt(el.getAttribute('data-max'), 10);
    var prefix = el.getAttribute('data-prefix');
    if (!min || !max || !prefix) return;
    function add(days) {
      var d = new Date();
      d.setHours(12, 0, 0, 0);
      while (days > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) days -= 1; }
      return d;
    }
    var wd = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var mo = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    function f(d) { return wd[d.getDay()] + ', ' + mo[d.getMonth()] + ' ' + d.getDate(); }
    try { el.textContent = prefix + ' ' + f(add(min)) + ' – ' + f(add(max)); } catch (e) {}
  }

  function buy() {
    var form = $('[data-fs-form]');
    if (!form) return;
    var holder = form.closest('[data-money]');
    var fmt = holder ? holder.getAttribute('data-money') : null;
    var idInput = $('[name="id"]', form);
    var priceEl = $('[data-fs-price]');
    var cmpEl = $('[data-fs-compare]');
    var afterEl = $('[data-fs-after]');
    var saveEls = $$('[data-fs-save-amt]');
    var btn = $('[data-fs-add]', form);
    var bar = $('[data-fs-bar]');
    var barMeta = $('[data-fs-bar-meta]');
    var barCmp = $('[data-fs-bar-compare]');
    var over = promoOver();
    if (over) $$('[data-fs-promo]').forEach(function (e) { e.hidden = true; e.style.display = 'none'; });
    function current() { return $('input[name="fs-size"]:checked', form); }
    var vmapEl = $('[data-fs-variants]'); var vmap = null; try { if (vmapEl) vmap = JSON.parse(vmapEl.textContent); } catch (e) {}
    function shadeVal() { var s = $('input[name="fs-shade"]:checked', form); return s ? s.value : null; }
    function resolve(r) { var sh = shadeVal(); if (!vmap || !sh) return { id: r.value, a: r.getAttribute('data-available') !== 'false' }; var o1 = r.getAttribute('data-o1'); for (var i = 0; i < vmap.length; i++) { if (vmap[i].o1 === o1 && vmap[i].o2 === sh) return { id: String(vmap[i].id), a: vmap[i].a }; } return { id: r.value, a: false }; }
    function plan() {
      var p = $('input[name="fs-plan"]:checked', form);
      if (!p || !p.value) return null;
      var list = (p.getAttribute('data-plans') || '').split('|').map(function (x) { var a = x.split('~'); return { id: a[0], name: a[1] }; });
      var r = current(); var n = r ? parseInt((r.getAttribute('data-title') || '1'), 10) || 1 : 1;
      var pick = list[Math.min(n, list.length) - 1] || list[0];
      return { id: parseInt(pick.id, 10), name: pick.name, pct: parseFloat(p.getAttribute('data-pct')) || 0 };
    }
    function sync() {
      var r = current();
      if (!r) return;
      var rv = resolve(r); idInput.value = rv.id;
      var cents = parseInt(r.getAttribute('data-price'), 10);
      var pl = plan(); var pn = $('[data-fs-plan-name]', form);
      if (pl) { cents = Math.round(cents * (100 - pl.pct) / 100); if (pn && pl.name) pn.textContent = pl.name; }
      var cmp = over ? 0 : (parseInt(r.getAttribute('data-compare'), 10) || 0);
      if (priceEl) priceEl.textContent = money(cents, fmt);
      if (cmp > cents) {
        if (cmpEl) cmpEl.textContent = money(cmp, fmt);
        if (afterEl) afterEl.textContent = money(cmp, fmt);
        if (barCmp) barCmp.textContent = money(cmp, fmt);
        saveEls.forEach(function (e) { e.textContent = money(cmp - cents, fmt, true); });
      }
      if (barMeta) barMeta.textContent = r.getAttribute('data-title') + (shadeVal() ? ' · ' + shadeVal() : '') + ' · ' + money(cents, fmt);
      var ok = rv.a;
      if (btn) { btn.disabled = !ok; btn.textContent = ok ? btn.getAttribute('data-label') + ' · ' + money(cents, fmt) : btn.getAttribute('data-soldout'); }
    }
    $$('input[name="fs-size"], input[name="fs-plan"], input[name="fs-shade"]', form).forEach(function (r) { r.addEventListener('change', sync); });
    sync();

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-busy'); }
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
        .catch(function () {})
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [(function () { var it = { id: parseInt(idInput.value, 10), quantity: 1 }; var pl = plan(); if (pl && pl.id) it.selling_plan = pl.id; return it; })()] })
          });
        })
        .then(function (res) { if (!res.ok) throw new Error('add'); window.location.href = '/checkout'; })
        .catch(function () { form.submit(); });
    });
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) sync(); });

    $$('[data-fs-buy]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (b.hasAttribute('data-fs-direct')) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); return; }
        var t = $('.fs-opt') || $('#fs-buy');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    if (bar && btn) {
      var foot = $('.shopify-section-group-footer-group') || $('footer:not(.fs-art__src)');
      var queued = false;
      var upd = function () {
        queued = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var past = btn.getBoundingClientRect().bottom < 0;
        var atFoot = foot ? foot.getBoundingClientRect().top < vh - 8 : false;
        var on = past && !atFoot;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      };
      var ask = function () { if (queued) return; queued = true; (window.requestAnimationFrame || window.setTimeout)(upd, 16); };
      document.addEventListener('scroll', ask, { passive: true, capture: true });
      window.addEventListener('resize', ask, { passive: true });
      window.addEventListener('hashchange', ask);
      upd();
    }
  }

  function reveal() {
    var els = $$('[data-fs-reveal]');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function ready() {
    try { gallery(); buy(); eta(); reveal(); } catch (err) { document.documentElement.classList.remove('fs-js'); }
    window.__fsReady = true;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
